import React from 'react'

const Socials = props => {
  return (
    <ul className="socials">
      <li><a rel="noopener noreferrer" target="_blank" href="https://www.facebook.com/onmecambio/"><i className="fab fa-facebook"></i></a></li>
      <li><a rel="noopener noreferrer" target="_blank" href="https://www.instagram.com/onmecambio/"><i className="fab fa-instagram"></i></a></li>
    </ul>
  )
}
export default Socials
